export default {
  searchCoursesStatus: '',
  searchCoursesType: '',
  searchCoursesCategory: '',
  searchCoursesTeacher: '',
  searchCoursesHot: '',
  searchCoursesLevel: '',
  searchCoursesFacult: ''
}



// WEBPACK FOOTER //
// ./src/components/courses/store/state.js